const PAYMENT_INTENT = 'payment_intent'; // URL param set externally
const SETUP_INTENT = 'setup_intent'; // URL param set externally
const PAYMENT_INTENT_CLIENT_SECRET = 'payment_intent_client_secret'; // URL param set externally
const SETUP_INTENT_CLIENT_SECRET = 'setup_intent_client_secret'; // URL param set externally

export const PAYMENT_URL_PARAMS = [
  PAYMENT_INTENT,
  SETUP_INTENT,
  PAYMENT_INTENT_CLIENT_SECRET,
  SETUP_INTENT_CLIENT_SECRET,
];
